<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai : Bil Pelbagai ">
           
             <z-table ref="tbluser" title="Senarai : Bil Pelbagai" :headers="table.headers" :items="table.items" :meta="table.meta" :filter="ffilter(search)">

             <template #zfilter>
              <z-input
                v-model="search.keyword"
                label="No. Bil"
                placeholder="No. Bil"
                class="table-bar-input">
              </z-input>

              <z-input
                v-model="search.tarikh_bil"
                label="Tarikh Bil"
                placeholder="No. Bil"
                type="date"
                class="xs2 table-bar-input">
              </z-input>

              <z-input
                v-model="search.tempoh_kredit"
                label="Tarikh Tempoh Kredit"
                placeholder="No. Bil"
                type="date"
                class="xs2 table-bar-input">
              </z-input>

              <z-lookup 
                label="Status"
                name="module"
                class="table-bar-lookup"
                :options="[{id: 1, label: 'Baharu', value: 1}, {id: 2, label: 'Bayar', value: 2}]"
                :sort="false"
                :cache="false"
                v-model="search.status"
              />

              <z-input
                v-model="search.profil"
                label="Profil"
                placeholder="Sila Masukkan maklumat yang ingin ditapis..."
                inner-icon-left="fal fa-filter"
                class="xs2 table-bar-input">
              </z-input>

              <w-button
                class="btn-search"
                @click="searchadvance = !searchadvance"
              >
                <w-icon>fal fa-sliders-v</w-icon>
              </w-button>

              <w-button
                class="btn-search"
                @click="searchreset"
              >
                <w-icon>fal fa-redo</w-icon>
              </w-button>

              <w-button
                class="btn-search pr3"
              >
                <w-icon>fal fa-search</w-icon>
              </w-button>

              
            </template>

            <template #zslider>
            <w-transition-expand>
            <w-card
                v-show="searchadvance"
                class="bd0 table-bar-search-advance"
                >
                <div class="table-bar-search-advance-inner">advance search</div>
              </w-card>
            </w-transition-expand>
              
            </template>
                
                
                

                <template #item-cell.action="{ item, label, header, index }">
                  <w-flex class="flex justify-center">
                   <inertia-link :href="item.show">
                    <w-tooltip top>
                       <template #activator="{ on }">
                         <w-icon v-on="on" >
                           fal fa-file
                         </w-icon>
                       </template>
                       Papar
                     </w-tooltip>
                    </inertia-link>
                  </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
// import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'bilpelbagai',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Bil Pelbagai', route: '/bilpelbagai' },
        { label: 'Senarai', route: '/bilpelbagai' },
      ],
      form: {
        // id: 0,
        no: '',
        no_dokumen: '',
        },
        search: {
          keyword: '',
          no_bil: '',
          tarikh_bil: '',
          tempoh_kredit: '',
          status: '',
          profil: '',
        },
        searchadvance: false,
        ffilter: _.throttle(search => item  => {
          let keyword = search.keyword
          // dynamically get all the cols and concatenate all the columns into a single string for a faster lookup.
          let allCols = ''
          Object.keys(item).forEach(i => allCols += item[i])
          
          // Lookup the keyword variable in the string with case-insensitive flag.
          let module = true
          let regex =  new RegExp(keyword, 'i').test(allCols) 
          if(search.status == 1) {
            module = item.status == 'BAHARU'
          }
          else if(search.status == 2) {
            module = item.status == 'BAYAR'
          }
          return regex && module
        }, 100)
        }
  },
  methods: {
    searchreset() {
      this.search.keyword = ''
      this.search.status = 0
    }
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>